var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1154",
    "data-name": "Rectangle 1154",
    width: 20,
    height: 22,
    transform: "translate(-0.322 0.06)",
    fill: "#2e728c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11076",
    "data-name": "Group 11076",
    transform: "translate(-142 -220)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(142 220)",
    fill: "#77ffa5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3362",
    "data-name": "Group 3362",
    transform: "translate(157.322 233.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3361",
    "data-name": "Group 3361",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11048",
    "data-name": "Path 11048",
    d: "M15.512,7.685v-2.2A5.745,5.745,0,0,0,9.546,0,5.745,5.745,0,0,0,3.58,5.489v2.2A3.447,3.447,0,0,0,0,10.978v7.685a3.447,3.447,0,0,0,3.58,3.293H15.512a3.447,3.447,0,0,0,3.58-3.293V10.978a3.447,3.447,0,0,0-3.58-3.293m-9.546-2.2A3.447,3.447,0,0,1,9.546,2.2a3.447,3.447,0,0,1,3.58,3.293v2.2H5.966ZM16.706,18.662a1.149,1.149,0,0,1-1.193,1.1H3.58a1.149,1.149,0,0,1-1.193-1.1V10.978A1.149,1.149,0,0,1,3.58,9.88H15.512a1.149,1.149,0,0,1,1.193,1.1Z",
    transform: "translate(0 0.165)",
    fill: "#2e728c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcons);
export default __webpack_public_path__ + "static/media/lock-icons.d1b3eb89b7aa6dd74c571258bcb29537.svg";
export { ForwardRef as ReactComponent };